import { Button } from 'reactstrap';
import * as React from 'react';
import { TranslationFunction } from 'i18next';
import { inject, observer } from 'mobx-react';
import { Store } from './../../../stores';
import { translate } from 'react-i18next';
import { RouteComponentProps, withRouter } from 'react-router';

import './../createUserButton.scss';

interface IProps extends RouteComponentProps {
  t: TranslationFunction;
  Store?: Store;
  onClick: () => void;
}

const NewCustomerPopupButton = inject('Store')(
  observer(({ Store: mobix, t, onClick, history }: IProps) => {

    return (
      <Button
        className="add create-customer-button"
        color="primary"
        onClick={ onClick }
      >
        { t('newSubscription') }
      </Button>
    );
  })
);

export default translate(['Customer', 'Tenant'])(withRouter(NewCustomerPopupButton));
